module.exports = __webpack_public_path__ + "img/sfour.ef17de43.png";